import { render, staticRenderFns } from "./InstallationWizard.vue?vue&type=template&id=b7130028&scoped=true&"
import script from "./InstallationWizard.vue?vue&type=script&lang=ts&"
export * from "./InstallationWizard.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationWizard.vue?vue&type=style&index=0&id=b7130028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7130028",
  null
  
)

export default component.exports